/**
 * Wrap matches of any term in `terms` inside <mark>…</mark>.
 * Case-insensitive, handles overlapping terms by sorting longest first.
 * Safe against regex injection (escapes special chars).
 */
export function highlightMatches(text: string, terms: ReadonlyArray<string>): string {
  if (!text || !terms || terms.length === 0) return text ?? '';
  const sanitized = terms
    .filter((t) => t && t.length > 1)
    .map((t) => t.trim())
    .sort((a, b) => b.length - a.length)
    .map(escapeRegex);
  if (sanitized.length === 0) return text;
  const re = new RegExp(`(${sanitized.join('|')})`, 'gi');
  return text.replace(re, '<mark>$1</mark>');
}

function escapeRegex(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
